import styled from 'styled-components';

export const Input = ({
	$error,
	label,
	name,
	onChange,
	type,
	inputmode,
	inputSize,
	placeholder,
	value,
	pattern,
	maxLength,
	max,
	min,
	disabled
}: InputProps & ContainerProps): JSX.Element => {
	return (
		<Container inputSize={inputSize}>
			{label && <Label>{label}</Label>}
			<StyledInput
				label={label}
				name={name}
				onChange={onChange}
				type={type}
				inputmode={inputmode}
				placeholder={placeholder}
				value={value}
				$error={$error}
				pattern={pattern}
				maxLength={maxLength}
				max={max}
				min={min}
				disabled={disabled}
			/>
			{$error && <ErrorDiv>{$error}</ErrorDiv>}
		</Container>
	);
};

export default Input;

interface InputProps {
	name?: string;
	label?: string;
	type?: string;
	inputmode?: string;
	defaultValue?: string;
	size?: string;
	value?: string | number;
	placeholder?: string;
	$error?: string | null;
	onChange?: (e: any) => void;
	pattern?: string;
	maxLength?: number;
	max?: string | number;
	min?: string | number;
	disabled?: boolean;
}

const Container = styled.div<ContainerProps>`
	width: ${props =>
		props.inputSize === 'twoThird'
			? '66%'
			: props.inputSize === 'third'
				? '33%'
				: props.inputSize === 'half'
					? '50%'
					: props.inputSize === 'full'
						? '100%'
						: '100%'};
	color: #575757;
	font-weight: bold;
`;

interface ContainerProps {
	inputSize?: string;
}

const Label = styled.label`
	font-size: 18px;
	margin-bottom: 12px;
`;

const StyledInput = styled.input<InputProps>`
	width: 100%;
	padding: 8px;
	box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.04);
	background: transparent;
	height: 40px;
	border: 1px solid;
	border-radius: 4px;
	border-color: ${props => (props.$error ? '#db2828' : '#d9d9d9')};
	color: #575757;
	font-weight: bold;

	::placeholder {
		color: #575757;
		font-weight: bold;
	}
`;

const ErrorDiv = styled.div`
	margin-top: 8px;
	color: #db2828 !important;
	font-weight: bold;
	font-size: 90%;
	line-height: 125%;
	margin-bottom: 0;
`;
